//axios configurations
export const apiUrl = process.env.VUE_APP_API_URL;
export const clientId = process.env.VUE_APP_CLIENT_ID;
export const clientSecret = process.env.VUE_APP_CLIENT_SECRET;

// alolia
export const algolia_app_id = process.env.VUE_APP_ALGOLIA_APP_ID || '';
export const algolia_api_key = process.env.VUE_APP_ALGOLIA_API_KEY || '';

export const companyPhone = '+358 44 231 5269';
export const companyEmail = 'info@taiko.art';
export const supportEmail = 'support@taiko.art';

// Mailchimp configurations
export const mailchimpId = {
  en: '958b23db93',
  fi: '96c6f0decd',
  se: '239c04049f'
};

// Default test wall
export const defaultWall = {
  id: 'default',
  img: '/static/rooms/1_white_wall.jpg',
  thumb: '/static/rooms/1_white_wall_thumb.jpg'
};

// Test walls
export const walls = [
  // (default) White wall is manually added in TestWalls.vue
  // wall width in cm
  {
    id: 1,
    img: '/static/rooms/S1_taikotest.jpg',
    thumb: '/static/rooms/S1_taikotest_thumb.jpg',
    sizeRange: 'S',
    width: 150
  },
  {
    id: 2,
    img: '/static/rooms/S2_taikotest.jpg',
    thumb: '/static/rooms/S2_taikotest_thumb.jpg',
    sizeRange: 'S',
    width: 150
  },
  {
    id: 3,
    img: '/static/rooms/S3_taikotest.jpg',
    thumb: '/static/rooms/S3_taikotest_thumb.jpg',
    sizeRange: 'S',
    width: 150
  },
  {
    id: 4,
    img: '/static/rooms/M1_taikotest.jpg',
    thumb: '/static/rooms/M1_taikotest_thumb.jpg',
    sizeRange: 'M',
    width: 250
  },
  {
    id: 5,
    img: '/static/rooms/M2_taikotest.jpg',
    thumb: '/static/rooms/M2_taikotest_thumb.jpg',
    sizeRange: 'M',
    width: 250
  },
  {
    id: 6,
    img: '/static/rooms/M3_taikotest.jpg',
    thumb: '/static/rooms/M3_taikotest_thumb.jpg',
    sizeRange: 'M',
    width: 250
  },
  {
    id: 7,
    img: '/static/rooms/L1_taikotest.jpg',
    thumb: '/static/rooms/L1_taikotest_thumb.jpg',
    sizeRange: 'L',
    width: 350
  },
  {
    id: 8,
    img: '/static/rooms/L2_taikotest.jpg',
    thumb: '/static/rooms/L2_taikotest_thumb.jpg',
    sizeRange: 'L',
    width: 350
  },
  {
    id: 9,
    img: '/static/rooms/L3_taikotest.jpg',
    thumb: '/static/rooms/L3_taikotest_thumb.jpg',
    sizeRange: 'L',
    width: 350
  },
  {
    id: 10,
    img: '/static/rooms/XL1_taikotest.jpg',
    thumb: '/static/rooms/XL1_taikotest_thumb.jpg',
    sizeRange: 'XL',
    width: 450
  },
  {
    id: 11,
    img: '/static/rooms/XL2_taikotest.jpg',
    thumb: '/static/rooms/XL2_taikotest_thumb.jpg',
    sizeRange: 'XL',
    width: 450
  },
  {
    id: 12,
    img: '/static/rooms/XL3_taikotest.jpg',
    thumb: '/static/rooms/XL3_taikotest_thumb.jpg',
    sizeRange: 'XL',
    width: 450
  },
];

// Colors for search filter
export const colors = [
  { id: 1, name: 'chip_black', color: 'black' },
  { id: 2, name: 'chip_white', color: 'white' },
  { id: 3, name: 'chip_gray', color: 'gray' },
  { id: 4, name: 'chip_red', color: 'red' },
  { id: 5, name: 'chip_green', color: 'green' },
  { id: 6, name: 'chip_blue', color: 'blue' },
  { id: 7, name: 'chip_pink', color: 'pink' },
  { id: 8, name: 'chip_yellow', color: 'yellow' },
  { id: 9, name: 'chip_orange', color: 'orange' },
  { id: 10, name: 'chip_purple', color: 'purple' },
  { id: 12, name: 'chip_brown', color: 'brown' },
  { id: 13, name: 'chip_cyan', color: 'cyan' },
  { id: 14, name: 'chip_grayscale', color: 'grayscale' }
];

// NOTE: keys are used for mapping from link resource
// Please refer to production translations, techniques slugs should match to production translations
// Technique slugs MUST BE in alphabetical order to avoid route jumping (triggers unnecessary FB pixel request).
export const categories = [
  {
    title: 'ARTWORK.PAINTINGS',
    image: '/static/lifts/painting.jpg',
    slug: 'painting',
    techniques: ['acryl', 'aquarelle', 'digital-painting', 'drawing', 'gouache', 'mixed-technique', 'muste', 'oil', 'pastel', 'tempera']
  },
  {
    title: 'ARTWORK.SCULPTURE',
    image: '/static/lifts/sculpture.jpg',
    slug: 'sculpture',
    techniques: ['ceramics', 'glass', 'gypsum', 'metal', 'mixed-technique-2', 'stone', 'tekstiili', 'wood']
  },
  {
    title: 'ARTWORK.PHOTOGRAPHY',
    image: '/static/lifts/photo.jpg',
    slug: 'photography',
    techniques: ['black-and-white', 'color']
  },
  {
    title: 'ARTWORK.GRAPHIC_PRINT',
    image: '/static/lifts/print.jpg',
    slug: 'graphic-print',
    techniques: ['digital-print', 'drawing-1', 'intaglio', 'mixed-technique-1', 'monotype', 'planographic-printing', 'relief-printing', 'serigraphy']
  }
];

// NOTE: values are used for mapping from link resource
export const sortTypes = [
  { i18Text: 'SEARCH.LATEST', value: 'artworks' },
  { i18Text: 'SEARCH.MOST_VIEWED', value: 'artworks_views_desc' },
  { i18Text: 'SEARCH.PRICE_ASC', value: 'artworks_price_asc' },
  { i18Text: 'SEARCH.PRICE_DESC', value: 'artworks_price_desc' },
  { i18Text: 'SEARCH.COLOR', value: 'color' },
];


// Langding page seo texts
export const categorySeoTexts = {
  painting: {
    en:
      `Paintings are perhaps the most common technique within visual arts. Taiko offers thousands of unique paintings, for instance oil, acrylic and aquarelles. Paintings vary from abstract color plays to detailed figurative works. Popular motives on Taiko are for instance nature, landscapes and animals, but the interest for abstract art is also growing.
      \nA painting can be created on different materials, such as canvas or on a wooden/metal board, depending on what kind of mood and ambience the artist is looking for. The same goes for the paint itself.
      \nAll paintings on Taiko are unique, and they can not be bought elsewhere. Taiko sells paintings by both established artists as well as by new, rising names. All artworks on Taiko are curated, which means that you are certain to receive art of high quality created by a professional artist.`,
    fi:
      `Maalaustaide pitää jatkuvasti pintansa suosittuna kuvataiteen muotona. Taikon valikoimassa on tuhansia uniikkeja maalauksia, kuten öljymaalauksia, akryylimaalauksia ja akvarelleja.
      \nEsittävät maalaukset, esimerkiksi maisemamaalaukset, kuuluvat jatkuvasti ostetuimpien joukkoon. Abstrakti taide kasvattaa tosin koko ajan suosiotaan.
      \nMaalaustaide voi olla abstraktia väreillä leikittelyä tai yksityiskohtaisen tarkkoja, esittäviä kuvia. Teoksen toteutuksessa voidaan käyttää monenlaisia eri pohjia, kuten kangasta, puuta, metallia tai pleksiä, ja maali valitaan pohjan ja taiteilijan tavoitteleman ilmeen ja tuntuman perusteella. Taikossa myynnissä olevat maalaukset, kansankielellä taulut, ovat aina uniikkeja taideteoksia, eikä niitä voi ostaa muualta kuin Taikosta.
      \nTaiko myy tauluja netissä sadoilta suomalaisilta taiteilijoilta; niin nuorilta nousevilta nimiltä kuin nimekkäiltä taiteilijoiltakin. Kaikki myynnissä oleva taide on kuratoitua, joten voit olla varma, että sinulle toimitetaan korkealuokkaista ammattitaiteilijan luomaa maalaustaidetta.`,
    se:
      `Målarkonsten är den kanske kändaste formen av bildkonst. Taiko erbjuder tusentals unika målningar, exempelvis olje- och akrylmålningar samt akvareller. Målningar kan vara abstrakta, där färger och former står i fokus, eller föreställande, det vill säga figurativa. Populära motiv är bland annat natur, landskap och djur, men abstrakt konst intresserar också allt fler.
      \nEn målning kan skapas på olika material, så som på duk eller på en trä-, metall- eller akrylskiva, beroende på vilket material som konstnären anser att vara lämpligast för det planerade konstverket.
      \nDe målningar som säljs på Taiko är unika, och de kan inte köpas annanstans ifrån. Taiko säljer målningar, eller mer folkligt tavlor, av hundratals etablerade och nya, unga yrkeskonstnärer. All konst som säljs på Taiko är kurerad, så du kan vara säker på att få högklassig konst skapad av en yrkeskonstnär.
      \nSe Taikos övriga konstformer: konstgrafik, fotokonst, skulpturer. (link to respective landing page under each category).`
  },
  sculpture: {
    en:
      `Do you have room for a sculpture in your home or in the office? Sculptures are trendy nowadays, and their three-dimensional form actually give a more lively impression compared to an artwork hanging on a wall.
      \nSculpting is an art form, in which the artistic expression comes through in a three-dimensional form. Sculptures are almost always unique, which means that there is only one version of them. Sculptures can be made of many different materials, for example stone, wood, clay, plaster, glass or different metals. Sculptures can be abstract or figurative, or something in between.
      \nPeople often tend to see sculptures as fancy and pricey, which is not necessarily true. On Taiko, there are hundreds of sculptures in many different price categories.`,
    fi:
      `Sopisiko kotiisi tai toimistoosi veistos? Veistokset ovat taas trendikkäitä, ja ne antavat kolmiulotteisina toisenlaisen, monen mielestä elävämmän, kokemuksen kuin seinälle ripustettu teos. Veistos sopii myös tilaan, jossa on lasiseinät tai jo paljon tauluja.
      \nSanaa veistos käytetään kuvaamaan kaikkia kolmiulotteisia taideteoksia. Veistokset ovat lähes aina uniikkeja, eli niitä tehdään vain yksi kappale. Veistoksia voidaan tehdä useista eri materiaaleista, kuten puusta, savesta, kipsistä, kivestä, lasista tai metallista. Veistokset voivat olla tasolle tai seinälle asetettavia patsaita tai korkokuvia eli reliefejä.
      \nVeistoksiin suhtaudutaan edelleenkin ehkä turhan juhlavasti. Niitä pidetään usein kalliina, mikä ei välttämättä pidä lainkaan paikkaansa. Taikon valikoimassa on satoja veistoksia eri hintakategorioissa, joten jokaiseen budjettiin löytyy sopiva teos.`,
    se:
      `Kunde en skulptur passa i ditt hem eller på kontoret? Skulpturer är igen trendiga, och enligt många ger den tredimensionella formen ett annorlunda, mer livligt uttryck för utrymmet jämfört med konstverk som hängs upp på väggen.
      \nSkulpturer är så gott som alltid unika, vilket innebär att de skapas med andra ord endast i ett exemplar. Skulpturer kan framställas av flera olika material, exempelvis trä, lera, vax, sten, glas eller metall. Skulpturerna kan vara statyer som kan placeras på en yta eller på väggen, eller så kan de vara skulpterade tredimensionella bilder på plana underlag, så kallade reliefer. Skulpturerna kan vara figurativa eller abstrakta eller något där emellan.
      \nMan förhåller sig ofta onödigt festligt till skulpturer. Ett vanligt antagande är att skulpturer alltid är väldigt dyra, vilket inte stämmer. Det finns hundratals skulpturer i olika priskategorier på Taiko, och därmed finns det sannolikt något för alla smaker.`
  },
  photography: {
    en:
      `Photo art has become ever so popular, which is no surprise. Modern photo art fits many home and office decors, and it is also a relatively affordable way to start collecting art. Finnish photography is of high quality and internationally acclaimed
      \nPhotography is a method or visual art, where a photograph is used as an expression of art. Photo artists take photos as negatives or, more commonly nowadays, use digital technology. Much like printmaking, a photograph is a printable art form, often printed in series. In photo art the prints are called editions.
      \nAn edition of a photo artwork is often printed on high quality paper, after which it is framed with a passe-partout, glass and a frame of for instance wood or metal. Photographs can also be printed on aluminum, which means that they are ready to hang without a separate frame.`,
    fi:
      `Valokuvataide nostaa jatkuvasti suosiotaan - eikä ihme. Valokuvataide sopii monenlaiseen sisustukseen, ja lisäksi se on helppo ja suhteellisen edullinen tapa aloittaa taiteen kerääminen. Suomalainen valokuvataide on korkealuokkaista ja maailmalla tunnettua.
      \nValokuva on monistettava taidemuoto, josta taiteilija voi vedostaa haluamansa määrän vedoksia. Valokuvataiteessa teoksen vedosmäärästä käytetään termiä editio.
      \nValokuvavedos on perinteisesti tulostettu korkealuokkaiselle paperille, joka kehystetään paspiksella, lasilla ja teoksen väreihin sopivalla kehyksellä. Nykyään valokuvia tulostetaan usein suoraan esimerkiksi alumiinilevylle, jolloin teos on suoraan ripustusvalmis. Valokuvia voidaan vedostaa eri tavoilla. Lue lisää tekniikoista Taiteen ABC -osiosta.`,
    se:
      `Fotokonst har blivit allt populärare, vilket inte är så märkligt. Modern fotokonst passar in i många slags inredningar, och det är dessutom ett relativt billigt alternativ att börja samla konst på. Finländsk fotokonst är högklassig och erkänd internationellt.
      \nFotokonst är en konstform, där man använder sig av fotografering för att uttrycka det konstnärliga bildspråket. Fotokonst är i likhet med konstgrafik en konstform som är reproducerbar, där konstnären kan välja hur många exemplar som framställs. I fotokonst används begreppet upplaga för att uppge antalet konstverk.
      \nEtt fotokonstverk är ofta framställt på högklassigt papper, som sedan ramas in med en passe-partout av papp, glas och en lämplig ram av exempelvis trä eller metall. Nuförtiden trycks fotografier allt oftare direkt på ett underlag så som aluminium, och då behövs ingen separat ram.
      `
  },
  'graphic-print': {
    en:
      `Printmaking is a convenient form of art for both beginners and collectors. Prints are usually affordable, which is why first time buyers often choose this alternative. A print is also a suitable gift.
      \nPrintmaking is the process of creating artworks by printing the image through a pressing plate, normally on paper. Printmaking sheets are printed as series. Every print is a unique artwork, and the number of artworks is decided in advance by the artist. By numbering and signing the work the artist validates every sheet. The numbering tells customers how many individual sheets the series has.
      \nDrawings also is another subcategory under printmaking. A drawing can be a quick sketch, for instance a croquis drawing of a live model, or a detailed drawing that takes a long time to create.
      \nDigital art where the artist creates imagery with for instance a computer, is also categorized as a form of printmaking.
      `,
    fi:
      `Taidegrafiikka on kätevä tapa aloittaa taiteen kerääminen. Taidegrafiikka on usein varsin edullista, joten moni taiteen ensiostaja valitsee grafiikkateoksen. Taidegrafiikka sopii myös mainiosti lahjaksi.
      \nTaidegrafiikassa kuva vedostetaan painolevyiltä paperille tai muulle materiaalille. Taidegrafiikka kehittyi, kun taiteilijat alkoivat hyödyntää teollisia painomenetelmiä taiteessa.
      \nGrafiikan vedoksia painetaan sarjoissa. Jokainen vedos on itsenäinen taideteos. Vedoksia vedostetaan ennalta päätetty määrä. Taiteilija vahvistaa sarjanumeroinnilla ja signeerauksella jokaisen hyväksymänsä vedoksen. Numerointi kertoo, montako kappaletta sarjasta on tehty.
      \nMyös piirustukset kuuluvat nykyään grafiikan alle. Taikossa on paljon piirustuksia, muun muassa nopeasti piirrettyjä useimmiten elävän mallin mukaan luotuja croquis-piirustuksia tai yksityiskohtaisia, isoja piirustuksia.
      \nGrafiikan alle kuuluu myös digitaalinen taide, jossa teos on luotu esimerkiksi tietokoneella.
      `,
    se:
      `Konstgrafik är ett behändigt sätt att köpa konst på. Grafik är ofta relativt billig, och därför väljer många förstagångsköpare just grafik. Ett grafikverk utgör också en lämplig gåva.
      \nKonstgrafik är en teknik där verket framställs från en tryckplatta på papper eller annat material. Grafiken utvecklades när konstnärerna började utnyttja olika industriella trycktekniker i konsten. Med hjälp av nya tekniska möjligheter har även tekniken för grafik blivit mångsidigare.
      \nGrafiska konstverk trycks i serier. Varje exemplar är ett unikt och självständigt konstverk. Mängden exemplar bestäms på förhand och konstnären bekräftar de godkända exemplaren med hjälp av serienumrering och signatur. Numreringen visar, hur många exemplar som gjorts i serien.
      \nOckså teckningar hör nuförtiden under grafik. Det finns en hel del teckningar på Taiko, både snabbt skapade och billiga sketcher, så som croquis-teckningar, och stora, detaljerade teckningar som tagit lång tid att skapa.
      \nOckså digital konst, skapad på till exempel dator, hör under konstgrafik.
      `
  }
};
